import React from 'react';
import Cookies from 'js-cookie';
import Navbar from './navbar';
import Footer from './footer';
import { Link } from 'react-router-dom';

const CookiePolicyPage = () => {
  const consent = Cookies.get('cookie_consent');
  const consentId = Cookies.get('cookie_consent_id');
  const consentDate = Cookies.get('cookie_consent_date');
  const preferencesCookie = Cookies.get('cookie_preferences');

  // Парсим JSON из 'cookie_preferences'
  let preferences = {};
  if (preferencesCookie) {
    try {
      preferences = JSON.parse(preferencesCookie);
    } catch (error) {
      preferences = {};
    }
  }

  // Определяем текущее состояние
  let currentState = 'Unknown';
  if (consent === 'all') {
    currentState = 'Allow all';
  } else if (consent === 'necessary') {
    currentState = 'Necessary only';
  } else if (consent === 'custom') {
    currentState = 'Custom settings';
  }

  // Преобразуем дату согласия в удобочитаемый формат
  const formattedDate = consentDate
    ? new Date(consentDate).toLocaleString()
    : 'No date';

  // При клике на "Change your consent" — диспатчим событие, которое поймает CookieConsentModal
  const handleChangeConsent = () => {
    window.dispatchEvent(
      new CustomEvent('openConsentModal', {
        detail: { showCustomize: true },
      })
    );
  };

  // Полный отказ (withdraw) — ставим "necessary"
  const handleWithdrawConsent = () => {
    Cookies.set('cookie_consent', 'necessary', { expires: 365 });
    Cookies.set(
      'cookie_preferences',
      JSON.stringify({
        necessary: true,
        analytics: false,
        marketing: false,
      }),
      { expires: 365 }
    );
    window.location.reload();
  };

  return (
    <>
      <Navbar />

      <section className="relative table w-full py-36 bg-[url('../../assets/images/bg/bg1.svg')] bg-bottom bg-no-repeat">
        <div className="absolute inset-0 bg-gradient-to-b from-transparent to-slate-900"></div>
        <div className="container">
          <div className="grid grid-cols-1 pb-8 text-center mt-10">
            <h3 className="md:text-3xl text-2xl md:leading-snug tracking-wide leading-snug font-medium text-white">
              Cookie Declaration
            </h3>
            <p className="text-slate-400">Last Updated: July 30, 2026</p>
          </div>
        </div>
        <div className="absolute text-center z-10 bottom-5 start-0 end-0 mx-3">
          <ul className="breadcrumb tracking-[0.5px] breadcrumb-light mb-0 inline-block">
            <li className="inline breadcrumb-item text-[15px] font-semibold duration-500 ease-in-out text-white/50 hover:text-white">
              <Link to="/">NIFTY</Link>
            </li>
            <li className="inline breadcrumb-item text-[15px] font-semibold duration-500 ease-in-out text-white" aria-current="page">
              Cookie Declaration
            </li>
          </ul>
        </div>
      </section>
      <div className="relative">
        <div className="shape absolute start-0 end-0 sm:-bottom-px -bottom-[2px] overflow-hidden z-1 text-white dark:text-slate-900">
          <svg className="w-full h-auto" viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
          </svg>
        </div>
      </div>

      <section className="relative md:py-24 py-16">
        <div className="container">
          <div className="md:flex justify-center">
            <div className="md:w-3/4">
              <div className="p-6 bg-white dark:bg-slate-900 shadow dark:shadow-gray-800 rounded-md">

                {/* 1. About cookies */}
                <h5 className="text-xl font-semibold mb-4">1. About Cookies</h5>
                <p className="text-slate-400">
                  NIFTY uses cookies and similar technologies to operate and secure{" "}
                  <a href="https://www.nifty-art.com/" className="underline text-violet-600 hover:text-violet-500">https://www.nifty-art.com/</a>, remember user preferences, and understand how visitors use the website.
                </p>
                <p className="text-slate-400 mt-3">
                  Cookies are small text files stored on your device when you visit a website. Some cookies are necessary for the website to function. Other cookies are optional and are used only where permitted by applicable law and, where required, after you provide consent.
                </p>

                {/* 2. How we use cookies */}
                <h5 className="text-xl font-semibold mb-4 mt-8">2. How We Use Cookies</h5>
                <p className="text-slate-400">
                  Strictly necessary cookies are set automatically because they are required for core website functions, including page navigation, account security, session management, fraud prevention, and recording your cookie preferences.
                </p>
                <p className="text-slate-400 mt-3">
                  Optional cookies, including statistics and analytics cookies, are used only according to your selected preferences and where the required consent has been obtained.
                </p>
                <p className="text-slate-400 mt-3">
                  We do not use optional cookies before consent where consent is required by applicable law.
                </p>

                {/* 3. Managing your preferences */}
                <h5 className="text-xl font-semibold mb-4 mt-8">3. Managing Your Preferences</h5>
                <p className="text-slate-400">
                  You may accept all optional cookies, reject non-essential cookies, or manage individual cookie categories through the cookie banner or cookie settings control available on the website.
                </p>
                <p className="text-slate-400 mt-3">
                  You may return to the cookie settings control at any time to review, change, or withdraw your consent. Withdrawing consent does not affect the lawfulness of processing carried out before consent was withdrawn.
                </p>
                <p className="text-slate-400 mt-3">
                  Disabling certain cookies may affect the performance or availability of some website features.
                </p>

                <div className="flex flex-wrap gap-4 mt-4">
                  <button
                    onClick={handleChangeConsent}
                    className="text-sm text-violet-600 underline hover:no-underline"
                  >
                    Change your consent
                  </button>
                  <button
                    onClick={handleWithdrawConsent}
                    className="text-sm text-violet-600 underline hover:no-underline"
                  >
                    Withdraw your consent
                  </button>
                </div>

                {/* 4. Consent details */}
                <h5 className="text-xl font-semibold mb-4 mt-8">4. Consent Details</h5>
                <p className="text-slate-400">Your consent applies to: nifty-art.com</p>
                <p className="text-slate-400 mt-3">
                  The following information is generated automatically by our cookie consent system and reflects your current preferences:
                </p>
                <p className="text-slate-400 mt-3">
                  Your current state: <span className="font-medium text-slate-500 dark:text-slate-300">{currentState}</span>
                </p>
                {consentId && (
                  <p className="text-slate-400 mt-2">
                    Your consent ID: <span className="font-medium text-slate-500 dark:text-slate-300">{consentId}</span>
                  </p>
                )}
                <p className="text-slate-400 mt-2">
                  Consent date: <span className="font-medium text-slate-500 dark:text-slate-300">{formattedDate}</span>
                </p>

                {/* 5. Cookie categories */}
                <h5 className="text-xl font-semibold mb-4 mt-8">5. Cookie Categories</h5>

                <h6 className="text-base font-semibold mb-2 mt-6">Strictly necessary</h6>
                <p className="text-slate-400">
                  These cookies are required to make the website usable and secure. They support functions such as navigation, access to secure areas, account sessions, payment flow, fraud prevention, and storage of cookie preferences.
                </p>
                <p className="text-slate-400 mt-3">
                  These cookies cannot ordinarily be disabled through the cookie settings control because the website may not function correctly without them.
                </p>

                <h6 className="text-base font-semibold mb-2 mt-6">Statistics and analytics</h6>
                <p className="text-slate-400">
                  These cookies help us understand how visitors interact with the website by collecting information about pages viewed, navigation activity, device and browser information, performance, and errors.
                </p>
                <p className="text-slate-400 mt-3">
                  The information is used to analyse website usage, improve functionality, diagnose technical issues, and optimise user experience. Statistics and analytics cookies are used only where the required consent has been provided.
                </p>

                {/* 6. Cookie details */}
                <h5 className="text-xl font-semibold mb-4 mt-8">6. Cookie Details</h5>
                <p className="text-slate-400">
                  The current list of cookies and similar technologies used by the website is shown below and updated by the cookie consent system. For each cookie, the declaration identifies the cookie name, provider, purpose, category, expiry period, and technology or type.
                </p>

                <h6 className="text-base font-semibold mb-2 mt-6">Strictly necessary (1)</h6>
                <div className="overflow-x-auto">
                  <table className="w-full mb-8 border text-sm border-slate-200 dark:border-slate-700">
                    <thead>
                      <tr className="border-b bg-gray-50 dark:bg-slate-800">
                        <th className="p-2 text-left">Name</th>
                        <th className="p-2 text-left">Provider</th>
                        <th className="p-2 text-left">Purpose</th>
                        <th className="p-2 text-left">Max Duration</th>
                        <th className="p-2 text-left">Type</th>
                      </tr>
                    </thead>
                    <tbody className="text-slate-400">
                      <tr className="border-b">
                        <td className="p-2">CookieConsent</td>
                        <td className="p-2">nifty-art.com</td>
                        <td className="p-2">
                          Stores the user's cookie consent state for the current domain
                        </td>
                        <td className="p-2">1 year</td>
                        <td className="p-2">HTTP Cookie</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <h6 className="text-base font-semibold mb-2 mt-6">Statistics and analytics (2)</h6>
                <div className="overflow-x-auto">
                  <table className="w-full mb-4 border text-sm border-slate-200 dark:border-slate-700">
                    <thead>
                      <tr className="border-b bg-gray-50 dark:bg-slate-800">
                        <th className="p-2 text-left">Name</th>
                        <th className="p-2 text-left">Provider</th>
                        <th className="p-2 text-left">Purpose</th>
                        <th className="p-2 text-left">Max Duration</th>
                        <th className="p-2 text-left">Type</th>
                      </tr>
                    </thead>
                    <tbody className="text-slate-400">
                      <tr className="border-b">
                        <td className="p-2">_ga</td>
                        <td className="p-2">Google</td>
                        <td className="p-2">
                          Used to send data to Google Analytics about the visitor's device and behavior.
                          Tracks the visitor across devices and marketing channels.
                        </td>
                        <td className="p-2">2 years</td>
                        <td className="p-2">HTTP Cookie</td>
                      </tr>
                      <tr>
                        <td className="p-2">_ga_#</td>
                        <td className="p-2">Google</td>
                        <td className="p-2">
                          Used to send data to Google Analytics about the visitor's device and behavior.
                          Tracks the visitor across devices and marketing channels.
                        </td>
                        <td className="p-2">2 years</td>
                        <td className="p-2">HTTP Cookie</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                {/* 7. Third-party cookies */}
                <h5 className="text-xl font-semibold mb-4 mt-8">7. Third-Party Cookies</h5>
                <p className="text-slate-400">
                  Some cookies may be placed or accessed by third-party service providers that support website analytics, security, payment processing, hosting, or other technical functions.
                </p>
                <p className="text-slate-400 mt-3">
                  Such third parties may process information under their own privacy and cookie notices. Optional third-party cookies are used only where permitted by law and, where required, after consent.
                </p>

                {/* 8. Further information */}
                <h5 className="text-xl font-semibold mb-4 mt-8">8. Further Information</h5>
                <p className="text-slate-400">
                  For more information about how we process personal data and use cookies, please review our{" "}
                  <Link to="/privacy" className="underline text-violet-600 hover:text-violet-500">
                    Cookie &amp; Privacy Policy
                  </Link>.
                </p>
                <p className="text-slate-400 mt-3">
                  Questions about this Cookie Declaration may be sent to:
                </p>
                <p className="text-slate-400 mt-2">
                  JADEFIRST LIMITED<br />
                  Company No. 15932126<br />
                  Registered address: 72 Halliwick Road, London, England, N10 1AB<br />
                  Email:{" "}
                  <a href="mailto:info@nifty-art.com" className="underline text-violet-600 hover:text-violet-500">
                    info@nifty-art.com
                  </a>
                </p>

              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default CookiePolicyPage;
